define([
	"dojo/_base/declare",
	"csi/heading/String"
], function(declare,StringRen) {

	return declare(StringRen, {
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: if old revision, then hide comment
			return (ctx.view.bHideOldComments && ctx.getNode().OldComment) ? false : this.inherited(arguments);
		},

		/**
		 * @override
		 * enable drag-fill
		 */
		canCopy: function(ctxCopy, h) {
			return true;
		}
	});
});